module.exports = __webpack_public_path__ + "img/LinearRegression.a5aff9ff.png";